const notSupported = (moduleName: string, fnName?: string): never => {
	const suffix = fnName ? `.${fnName}` : ''
	throw new Error(`${moduleName}${suffix} is not available in the browser build.`)
}

const makeThrower = (moduleName: string, fnName: string) => () => notSupported(moduleName, fnName)

const fs = {
	readFileSync: makeThrower('fs', 'readFileSync'),
	writeFileSync: makeThrower('fs', 'writeFileSync'),
	createReadStream: makeThrower('fs', 'createReadStream'),
	createWriteStream: makeThrower('fs', 'createWriteStream'),
	promises: {
		readFile: makeThrower('fs.promises', 'readFile'),
		writeFile: makeThrower('fs.promises', 'writeFile'),
	},
}

const https = {
	get: makeThrower('https', 'get'),
	request: makeThrower('https', 'request'),
}

export { fs, https }
export default {
	...fs,
	...https,
	promises: fs.promises,
}
